module.exports = __webpack_public_path__ + "static/media/han-taste-ad3.553b9606.jpg";